import React, { Fragment } from 'react';
import { translate as t } from '../../lib/I18n';
import config from '../../config';
import Link from '../general/Link';
import { PointStages } from '../../constants/AppConstants';
import FeatureFlagStore from '../../stores/FeatureFlagStore';

export const Logo = () => {
    const brandMainSiteUrl = config.get('mainSiteUrl');
    const isProd = config.get('environment') === 'prod';
    const enableLogoRedirectToSearchPage = !isProd || FeatureFlagStore.get('enableLogoRedirectToSearchPage');

    const commonProps = {
        tabIndex: '0',
        className: 'header__logo sr-container',
        'data-test-id': 'site-header-logo-link',
    };

    const LogoContent = (
        <Fragment>
            <img aria-hidden="true" src={`/images/logos/${config.get('brand')}-logo.png`} alt={`${t('app.owner')} logo`} />
            <span className="sr-text">{ t('app.owner') }</span>
        </Fragment>
    );

    if (enableLogoRedirectToSearchPage) {
        return (
            <Link to={PointStages.SEARCH} {...commonProps}>
                {LogoContent}
            </Link>
        );
    }

    return (
        <a href={brandMainSiteUrl} {...commonProps}>
            {LogoContent}
        </a>
    );
};
